import { CONTACT_EMAIL, CONTACT_SOCIAL } from "../data/contact.js";

export const SITE_NAME = "CJ Photos";
export const SITE_BRAND = "CJ.PHOTOS";
export const SITE_OWNER = "CJ Jayamaha";
export const SITE_TAGLINE =
  "Photographer, storyteller, explorer, and product leader documenting wildlife, travel, motorsport, and the journeys that shape them.";
export const SITE_DEFAULT_DESCRIPTION =
  "CJ Jayamaha — photography, long-form stories, films, and field notes from wildlife conservation, adventure travel, motorsport, and product leadership.";
export const SITE_DEFAULT_OG_IMAGE = "og/home.jpg";
export const SITE_DEFAULT_OG_IMAGE_WIDTH = 1200;
export const SITE_DEFAULT_OG_IMAGE_HEIGHT = 630;
export const SITE_DEFAULT_OG_IMAGE_TYPE = "image/jpeg";
/** Twitter/X prefers 2:1 (1200×600); FB, LinkedIn, and WhatsApp use og:image at 1.91:1. */
export const SITE_DEFAULT_TWITTER_IMAGE = "og/home-twitter.jpg";
export const SITE_DEFAULT_TWITTER_IMAGE_WIDTH = 1200;
export const SITE_DEFAULT_TWITTER_IMAGE_HEIGHT = 600;
export const SITE_DEFAULT_OG_IMAGE_ALT =
  "African leopard portrait — The Moment She Looked Back, by CJ Jayamaha";
export const SITE_HOME_TITLE = "My Journey thus far - Photography, Stories & Field Notes";
export const SITE_LOCALE = "en_GB";
export const SITE_LANGUAGE = "en";

/** @returns {string} */
export function getSiteUrl() {
  const fromEnv = process.env.REACT_APP_SITE_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/\/$/, "");
  }
  return "https://cj.photos";
}

export const SITE_SOCIAL_PROFILES = CONTACT_SOCIAL.map((item) => item.href);

export const SITE_CONTACT = {
  email: CONTACT_EMAIL,
  contactType: "customer support",
};
